import { FeeCategory } from '../types';

export const mockFeeCategories: FeeCategory[] = [
  {
    id: '1',
    name: 'Donations',
    description: 'Voluntary contributions to support school programs and activities',
    icon: 'Favorite',
    color: '#e91e63',
    isActive: true,
  },
  {
    id: '2',
    name: 'Bus Pass',
    description: 'Transportation passes for school bus services',
    icon: 'DirectionsBus',
    color: '#ff9800',
    isActive: true,
  },
  {
    id: '3',
    name: 'Classroom Supplies',
    description: 'Required materials and supplies for classroom activities',
    icon: 'School',
    color: '#2196f3',
    isActive: true,
  },
  {
    id: '4',
    name: 'Field Trips',
    description: 'Educational trips and excursions',
    icon: 'Explore',
    color: '#4caf50',
    isActive: true,
  },
  {
    id: '5',
    name: 'Event Tickets',
    description: 'Tickets for school events, performances, and activities',
    icon: 'ConfirmationNumber',
    color: '#9c27b0',
    isActive: true,
  },
  {
    id: '6',
    name: 'Other',
    description: 'Miscellaneous fees and charges',
    icon: 'MoreHoriz',
    color: '#607d8b',
    isActive: true,
  },
  {
    id: '7',
    name: 'Concessions',
    description: 'Food, drinks, and snacks sold at events and concession stands',
    icon: 'Fastfood',
    color: '#f59e0b',
    isActive: true,
  },
];
